import { HomePage } from 'pages/HomePage';
import { SignInPage } from 'pages/SignInPage';
import { AuthCodePage } from 'pages/AuthCodePage';
import { useRoutes } from 'react-router';
import { DashboardPage } from 'pages/DashboardPage';
import { LoginPage } from 'pages/LoginPage';
import { GeneralSettingsPage } from 'pages/GeneralSettingsPage';
import { SupportedCountriesPage } from 'pages/SupportedCountriesPage';
import { ContractPage } from 'pages/ContractPage';
import { PaymentMethodsPage } from 'pages/PaymentMethodsPage';
import { SecuritySettingsPage } from 'pages/SecuritySettingsPage';
import { OrdersPage } from 'pages/OrdersPage';
import { OrderPage } from 'pages/OrderPage';
import { RefundsPage } from 'pages/RefundsPage';
import { RefundPage } from 'pages/RefundPage';
import { InvoicesPage } from 'pages/InvoicesPage';
import { SalesReportsPage } from 'pages/SalesReportsPage';
import { VatReportsPage } from 'pages/VatReportsPage';
import { VatCorrectionsPage } from 'pages/VatCorrectionsPage';
import { PricingPage } from 'pages/PricingPage';
import { NotFoundPage } from 'pages/404';
import { IntegrationsPage } from 'pages/IntegrationsPage';
import { ShipmentsPage } from 'pages/ShipmentsPage';
import { ShipmentPage } from 'pages/ShipmentPage';
import { HmrcPage } from 'pages/HmrcPage';
import { GpsrServicePage } from 'pages/GpsrServicePage';
import { GpsrSkuPage } from 'pages/GpsrSkuPage';
import { EudrServicePage } from 'pages/EudrServicePage';
import { EudrFilesPage } from 'pages/EudrFilesPage';
import { EuDdpPage } from 'pages/EuDdpPage';
import { EuDdpOrderPage } from 'pages/EuDdpOrderPage';
import { EprPpwrPage } from 'pages/EprPpwrPage';
import { PpwrManualReportPage } from 'pages/PpwrManualReportPage';
import { PpwrPackingProfilePage } from 'pages/PpwrPackingProfilePage';
import { PpwrCountryExclusionPage } from 'pages/PpwrCountryExclusionPage';
import { ShopifyDevAppsPage } from 'pages/ShopifyDevAppsPage';
import { ShopifyDevAppPage } from 'pages/ShopifyDevAppPage';
import { PublicAttachmentUploadPage } from 'pages/PublicAttachmentUploadPage';
import { DownloadOrdersExportPage } from 'pages/DownloadOrdersExportPage';

import { InactivityPage } from 'pages/InactivityPage';
import { UploadedSalesReportsPage } from 'pages/UploadedSalesReportsPage';
import { UserManagementPage } from 'pages/UserManagementPage';
import { PATHS } from './constants';

export const NavigateList = () => {
	const routes = useRoutes([
		{
			path: PATHS.AUTH_CODE_PAGE,
			element: <AuthCodePage />,
		},
		// {
		// 	path: PATHS.AUTH_PAGE,
		// 	element: <AuthPage />,
		// },
		{
			path: PATHS.HOME_PAGE,
			element: <HomePage />,
		},
		{
			path: PATHS.SIGN_IN_PAGE,
			element: <SignInPage />,
		},
		{
			path: PATHS.INACTIVITY_PAGE,
			element: <InactivityPage />,
		},
		{
			path: PATHS.PUBLIC_ATTACHMENT_UPLOAD_PAGE,
			element: <PublicAttachmentUploadPage />,
		},
		{
			path: PATHS.DASHBOARD_PAGE,
			element: <DashboardPage />,
		},
		{
			path: PATHS.LOGIN_PAGE,
			element: <LoginPage />,
		},
		{
			path: PATHS.GENERAL_SETTINGS_PAGE,
			element: <GeneralSettingsPage />,
		},
		{
			path: PATHS.SUPPORTED_COUNTRIES_PAGE,
			element: <SupportedCountriesPage />,
		},
		{
			path: PATHS.CONTRACT_PAGE,
			element: <ContractPage />,
		},
		// {
		// 	path: PATHS.NOTIFICATION_SETTINGS_PAGE,
		// 	element: <NotificationSettingsPage />,
		// },
		{
			path: PATHS.USER_MANAGEMENT_PAGE,
			element: <UserManagementPage />,
		},
		{
			path: PATHS.PAYMENT_METHODS_PAGE,
			element: <PaymentMethodsPage />,
		},
		{
			path: PATHS.SECURITY_SETTINGS_PAGE,
			element: <SecuritySettingsPage />,
		},
		{
			path: PATHS.ORDERS_PAGE,
			element: <OrdersPage />,
		},
		{
			path: PATHS.ORDER_PAGE,
			element: <OrderPage />,
		},
		{
			path: PATHS.REFUNDS_PAGE,
			element: <RefundsPage />,
		},
		{
			path: PATHS.REFUND_PAGE,
			element: <RefundPage />,
		},
		{
			path: PATHS.INVOICES_PAGE,
			element: <InvoicesPage />,
		},
		{
			path: PATHS.SALES_REPORTS_PAGE,
			element: <SalesReportsPage />,
		},
		{
			path: PATHS.VAT_REPORTS_PAGE,
			element: <VatReportsPage />,
		},
		{
			path: PATHS.VAT_CORRECTIONS_PAGE,
			element: <VatCorrectionsPage />,
		},
		{
			path: PATHS.PRICING_PAGE,
			element: <PricingPage />,
		},
		{
			path: PATHS.INTEGRATIONS_PAGE,
			element: <IntegrationsPage />,
		},
		{
			path: PATHS.UPLOADED_SALES_REPORTS_PAGE,
			element: <UploadedSalesReportsPage />,
		},
		{
			path: PATHS.SHIPMENTS_PAGE,
			element: <ShipmentsPage />,
		},
		{
			path: PATHS.SHIPMENT_PAGE,
			element: <ShipmentPage />,
		},
		{
			path: PATHS.HMRC_AUTH_REDIRECT,
			element: <HmrcPage />,
		},
		{
			path: PATHS.GPSR_SERVICE_PAGE,
			element: <GpsrServicePage />,
		},
		{
			path: PATHS.EUDR_SERVICE_PAGE,
			element: <EudrServicePage />,
		},
		{
			path: PATHS.EUDR_FILES_PAGE,
			element: <EudrFilesPage />,
		},
		{
			path: PATHS.GPSR_SERVICE_SKU_PAGE,
			element: <GpsrSkuPage />,
		},
		{
			path: PATHS.EU_DDP_PAGE,
			element: <EuDdpPage />,
		},
		{
			path: PATHS.EU_DDP_ORDER_PAGE,
			element: <EuDdpOrderPage />,
		},
		{
			path: PATHS.EPR_PPWR_PAGE,
			element: <EprPpwrPage />,
		},
		{
			path: PATHS.PPWR_MANUAL_REPORT_PAGE,
			element: <PpwrManualReportPage />,
		},
		{
			path: PATHS.PPWR_PACKING_PROFILE_PAGE,
			element: <PpwrPackingProfilePage />,
		},
		{
			path: PATHS.PPWR_COUNTRY_EXCLUSION_PAGE,
			element: <PpwrCountryExclusionPage />,
		},
		{
			path: PATHS.SHOPIFY_DEV_APPS_PAGE,
			element: <ShopifyDevAppsPage />,
		},
		{
			path: PATHS.SHOPIFY_DEV_APP_PAGE,
			element: <ShopifyDevAppPage />,
		},
		{
			path: PATHS.DOWNLOAD_ORDERS_EXPORT_PAGE,
			element: <DownloadOrdersExportPage />,
		},
		{
			path: '*',
			element: <NotFoundPage />,
		},
	]);
	return routes;
};
